import React,{useEffect,useState} from 'react';
import HeaderOuter from '../Nav Bar/HeaderOuter'
import Faq from '../FAQ/Faq'
import { checkprotectedroutes} from '../../Global/Index'
import LayoutShortcut from '../Layout Shortcut/Shortcut'
import Cookies from 'js-cookie'

export const FaqOuter = () => {
    
  const encoded_token = Cookies.get('token');
    const [isAuthorized, setIsAuthorized] = useState(null); // State to track authorization

    useEffect(() => {
      const checkProtectedRoutes = async () => {
        if (!encoded_token) {
          window.location.href = '/';
          return;
        }
  
        const isProtected = await checkprotectedroutes();
        if (!isProtected) {
          Cookies.remove('token'); // Remove the token from cookies
        } else {
          setIsAuthorized(true); // Set authorized state to true
        }
      };
  
      checkProtectedRoutes();
    }, [encoded_token]); // Add token as a dependency
  
 
 
    if (!isAuthorized) {
      return <div>
          
          
      </div>; // Show a loading state while checking authorization
    }else{
  return (
    <>
    <HeaderOuter/>
    <Faq/>
    <LayoutShortcut/>
    </>
  )
}}
